import { InterceptorClient } from "../../interceptor/interceptorClient";
import { fetchContentFromCMSOnClient } from "../common";
import {
  CMS_CHATBOT_CONFIG,
  CMS_MY_ACCOUNT_PARTNERS,
  DELETE_ACCOUNT_ADDRESS,
  GET_ACCOUNT_SAVED_ADDRESSES,
  GET_CUST_COMM_PREF,
  GET_EDIT_SAVED_ADDRESS,
  GET_ORDER_PAYMENT_STATUS,
  GET_PARTNER_LOYALTY_CONTENT,
  GET_SENDER_MOBILE_COUNTRY,
  GET_USER_SUB_ORDERS,
  HIDE_USER_SUB_ORDER,
  REMOVE_EXPIRED_ORDER,
  UPDATE_ACCOUNT_ADDRESS,
  UPDATE_CUST_COMM_PREF,
  ORDER_UPDATE_MESSAGE,
  ORDER_UPDATE_SENDER_DETAILS,
  ORDER_EDIT_SHIPPING_ADDRESS,
  GET_CUSTOMER_PROFILE_DETAILS,
  UPDATE_CUSTOMER_PROFILE,
  GET_GIFT_COUPONS,
  GET_WALLET_STATEMENT,
} from "./constants";

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;

/**
 * @returns {Promise<object>}
 */
export async function getMyOrdersApi() {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_USER_SUB_ORDERS()}`, false);
  } catch (ex) {
    return ex;
  }
}

/**
 * @param {string} orderId
 * @returns {Promise<object>}
 */
export async function deleteExpiredProductApi(orderId) {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${REMOVE_EXPIRED_ORDER(orderId)}`, false);
}

/**
 * @param {string} subOrderId
 * @returns {Promise<object>}
 */
export async function deleteConfirmedOrderApi(subOrderId) {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${HIDE_USER_SUB_ORDER(subOrderId)}`, false);
}

/**
 * @param {string} orderId
 * @returns {Promise<object>}
 */
export async function getOrderPaymentPreferenceStatusApi(orderId) {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_ORDER_PAYMENT_STATUS(orderId)}`, false);
  } catch (ex) {
    return ex;
  }
}

/**
 * @param {string} subOrderId
 * @returns {Promise<object>}
 */
export async function getSenderMobileCountryCodeAndCityApi(subOrderId) {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_SENDER_MOBILE_COUNTRY(subOrderId)}`, false);
  } catch (ex) {
    return ex;
  }
}

/**
 * @returns {Promise<object>}
 */
export async function getPromotionalCommunicationApi() {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_CUST_COMM_PREF()}`, false);
  } catch (ex) {
    return ex;
  }
}

/**
 * @param {Record<string, string>} payload
 * @returns {Promise<object>}
 */
export async function setPromotionalCommunicationApi(payload) {
  const body = new URLSearchParams(payload).toString();
  return await InterceptorClient.getFNTSInstance(baseUrl).post(body, `${UPDATE_CUST_COMM_PREF()}`, false, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
}

/**
 * @returns {Promise<object>}
 */
export async function getChatBotConfigApi() {
  try {
    return await fetchContentFromCMSOnClient(CMS_CHATBOT_CONFIG);
  } catch (ex) {
    return ex;
  }
}

/**
 * @returns {Promise<object>}
 */
export async function getPartnersListApi() {
  try {
    return await fetchContentFromCMSOnClient(CMS_MY_ACCOUNT_PARTNERS);
  } catch (ex) {
    return ex;
  }
}

/**
 * @returns {Promise<object>}
 */
export async function getPartnerLoyaltyContentIdDetailsApi() {
  try {
    return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_PARTNER_LOYALTY_CONTENT()}`, false);
  } catch (ex) {
    return ex;
  }
}

/**
 * @returns {Promise<object>}
 */
export async function getAccountSavedAddressesApi() {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_ACCOUNT_SAVED_ADDRESSES()}`, false);
}

/**
 * @param {Record<string, string>} params
 * @returns {Promise<object>}
 */
export async function updateAccountAddressApi(params) {
  const body = new URLSearchParams(params).toString();
  return await InterceptorClient.getFNTSInstance(baseUrl).post(body, `${UPDATE_ACCOUNT_ADDRESS()}`, false, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
}

/**
 * @param {string} contactMechId
 * @returns {Promise<object>}
 */
export async function getEditSavedAddressApi(contactMechId) {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_EDIT_SAVED_ADDRESS(contactMechId)}`, false);
}

/**
 * @param {string} cartIndex
 * @param {string} contactMechId
 * @returns {Promise<object>}
 */
export async function deleteAccountAddressApi(contactMechId, cartIndex = "") {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(
    `${DELETE_ACCOUNT_ADDRESS(cartIndex, contactMechId)}`,
    false,
  );
}

/**
 * @param {Record<string, string>} params
 * @returns {Promise<object>}
 */
export async function updateOrderGiftMessagesApi(params) {
  const body = new URLSearchParams(params).toString();
  return await InterceptorClient.getFNTSInstance(baseUrl).post(body, `${ORDER_UPDATE_MESSAGE()}`, false, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
}

/**
 * @param {Record<string, string>} params
 * @returns {Promise<object>}
 */
export async function updateOrderSenderDetailsApi(params) {
  const body = new URLSearchParams(params).toString();
  return await InterceptorClient.getFNTSInstance(baseUrl).post(body, `${ORDER_UPDATE_SENDER_DETAILS()}`, false, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
}

/**
 * @param {Record<string, string>} params
 * @returns {Promise<object>}
 */
export async function updateOrderRecipientDetailsApi(params) {
  const body = new URLSearchParams(params).toString();
  return await InterceptorClient.getFNTSInstance(baseUrl).post(body, `${ORDER_EDIT_SHIPPING_ADDRESS()}`, false, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
}

/**
 * @returns {Promise<object>}
 */
export async function getCustomerProfileDetailsApi() {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_CUSTOMER_PROFILE_DETAILS()}`, false);
}

/**
 * @param {Record<string, string>} params
 * @returns {Promise<object>}
 */
export async function updateCustomerProfileApi(params) {
  const body = new URLSearchParams(params).toString();
  return await InterceptorClient.getFNTSInstance(baseUrl).post(body, `${UPDATE_CUSTOMER_PROFILE()}`, false, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
}

/**
 * @returns {Promise<object>}
 */
export async function getGiftCouponsApi() {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_GIFT_COUPONS()}`, false);
}

/**
 * @param {number} page
 * @param {number} viewSize
 * @returns {Promise<object>}
 */
export async function getWalletStatementApi(page = 1, viewSize = 40) {
  return await InterceptorClient.getFNTSInstance(baseUrl).get(`${GET_WALLET_STATEMENT(page, viewSize)}`, false);
}
